import React, { useState } from "react";
import arrow from "../../assets/right-arrow.png";
import axios from "axios";
import { focii_url, plugin_url } from "../../config";
import { store } from "../../Components/Redux/store";
import apiClient from "../../services/axiosInterceptor";

const SurveyModal = ({ setSurvey, videoId, setSuccessModal }) => {
  console.log("VideoId in modal", videoId);
  const [ratingOne, setRatingOne] = useState("");
  const [ratingSecond, setRatingSecond] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [remarks, setRemarks] = useState("");
  const _u = JSON.parse(store.getState().user.user);
  const token = _u?.sessionToken;

  //remove this and use above token

  const submitSurvey = async (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("userProfile");
    if (!userId) {
      return;
    }
    userId = JSON.parse(userId);

    const userEmail = userId["userDetails"]["email"];

    if (!ratingOne || !ratingSecond) {
      return;
    }
    // console.log(ratingOne, ratingSecond,remarks)
    console.log("Inside form submissionn");

    try {
      const data = {
        type: "consumer",
        sessionId: `${videoId}`,
        email: userEmail,
        formValues: [
          {
            fieldId: "q1",
            value: `${ratingOne}`,
          },
          {
            fieldId: "q2",
            value: `${ratingSecond}`,
          },
          {
            fieldId: "remark",
            value: `${remarks}`,
          },
        ],
      };
      setSubmitted(true);
      console.log("Making post request");
      const result = await axios.post(
        `${focii_url}/feedback/v1/feedback`,
        data,
        {
          headers: {
            "X-Access-Token": token,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(result);

      await apiClient.post(
        `${plugin_url}/plugin/api/task/updateFeedbackTaskPoint`,
        {
          videoId,
        }
      );
      console.log("Finished Request");
      localStorage.removeItem("videoId");
    } catch (error) {
      console.log("Not able to post feedback", error);
    }
    setSubmitted(false);
    setSurvey(false);
    setSuccessModal(true);
  };

  const handleRatingOneChange = (e) => {
    setRatingOne(e.target.value);
  };

  const handleRatingSecondChange = (e) => {
    setRatingSecond(e.target.value);
  };

  return (
    <div style={{ padding: "12px" }}>
      <div className="survey-modal-header">
        <h4>Almost There!</h4>
        <p>
          Your input helps us refine and deliver a better experience. Please
          take a moment to share your feedback, and thank you for being a part
          of our community!
        </p>
      </div>
      <div>
        <form>
          <div>
            <p className="survey-input-label">
              Please rate your overall experience with FOCII
            </p>
            <div className="survey-radio-inputs">
              <input
                type="radio"
                className="btn-check"
                name="options-base"
                id="option1"
                autoComplete="off"
                value="1"
                onChange={handleRatingOneChange}
              />
              <label className="btn survey-radio-input" htmlFor="option1">
                1
              </label>

              <input
                type="radio"
                className="btn-check"
                name="options-base"
                id="option2"
                autoComplete="off"
                value="2"
                onChange={handleRatingOneChange}
              />
              <label className="btn survey-radio-input" htmlFor="option2">
                2
              </label>

              <input
                type="radio"
                className="btn-check"
                name="options-base"
                id="option3"
                autoComplete="off"
                value="3"
                onChange={handleRatingOneChange}
              />
              <label className="btn survey-radio-input" htmlFor="option3">
                3
              </label>

              <input
                type="radio"
                className="btn-check"
                name="options-base"
                id="option4"
                autoComplete="off"
                value="4"
                onChange={handleRatingOneChange}
              />
              <label className="btn survey-radio-input" htmlFor="option4">
                4
              </label>
              <input
                type="radio"
                className="btn-check"
                name="options-base"
                id="option5"
                autoComplete="off"
                value="5"
                onChange={handleRatingOneChange}
              />
              <label className="btn survey-radio-input" htmlFor="option5">
                5
              </label>
            </div>
          </div>

          <div>
            <p className="survey-input-label">
              Please rate the performance of your system with FOCII
            </p>
            <div className="survey-radio-inputs">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="option6"
                autoComplete="off"
                value="1"
                onChange={handleRatingSecondChange}
              />
              <label className="btn survey-radio-input" htmlFor="option6">
                1
              </label>

              <input
                type="radio"
                className="btn-check"
                name="options"
                id="option7"
                autoComplete="off"
                value="2"
                onChange={handleRatingSecondChange}
              />
              <label className="btn survey-radio-input" htmlFor="option7">
                2
              </label>

              <input
                type="radio"
                className="btn-check"
                name="options"
                id="option8"
                autoComplete="off"
                value="3"
                onChange={handleRatingSecondChange}
              />
              <label className="btn survey-radio-input" htmlFor="option8">
                3
              </label>

              <input
                type="radio"
                className="btn-check"
                name="options"
                id="option9"
                autoComplete="off"
                value="4"
                onChange={handleRatingSecondChange}
              />
              <label className="btn survey-radio-input" htmlFor="option9">
                4
              </label>
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="option10"
                autoComplete="off"
                value="5"
                onChange={handleRatingSecondChange}
              />
              <label className="btn survey-radio-input" htmlFor="option10">
                5
              </label>
            </div>
          </div>
          <div className="survey-remark-input">
            <p className="survey-input-label">Additional Remarks</p>
            <input
              type="text"
              placeholder="Enter your remarks here"
              onChange={(e) => setRemarks(e.target.value)}
            />
          </div>
          <div className="survey-submit-btn">
            <button
              onClick={submitSurvey}
              disabled={!ratingOne || !ratingSecond || submitted ? true : false}
              //  disabled={true}
              className={
                !ratingOne || !ratingSecond || submitted ? "disable-btn" : ""
              }
              style={{ opacity: `${submitted ? 0.5 : 1}` }}
            >
              Submit <img src={arrow} alt="" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SurveyModal;
